import { VIEW_INVITATION_CLICKED, INVITEE_AUTHORIZED } from './actionTypes';

export const toggleInvitationVisible = () => ({
  type: VIEW_INVITATION_CLICKED,
});

export const inviteeAuthorized = () => ({
  type: INVITEE_AUTHORIZED,
});

export function viewInvitationClicked() {
  return dispatch => {
    dispatch(toggleInvitationVisible());
  };
}

export function inviteeViewedPageFirstTime() {
  return dispatch => {
    dispatch(inviteeAuthorized());
  }
}


// WEBPACK FOOTER //
// ./src/actions/invitation.js